var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckmarkArt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 255,
    height: 214,
    viewBox: "0 0 255 214",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M121.826 0.5C180.603 0.5 228.326 48.2228 228.326 107C228.326 165.777 180.603 213.5 121.826 213.5C63.049 213.5 15.3262 165.777 15.3262 107C15.3262 48.2228 63.049 0.5 121.826 0.5Z",
    fill: "url(#paint0_linear_235_112053)",
    stroke: "#EDF0FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M202.885 111.864C202.885 157.533 165.873 194.546 120.203 194.546C74.5338 194.546 37.5215 157.533 37.5215 111.864C37.5215 66.1942 74.5338 29.1819 120.203 29.1819C165.873 29.1819 202.885 66.1942 202.885 111.864Z",
    fill: "url(#paint1_linear_235_112053)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M202.885 102.136C202.885 147.806 165.873 184.818 120.203 184.818C74.5338 184.818 37.5215 147.806 37.5215 102.136C37.5215 56.4669 74.5338 19.4546 120.203 19.4546C165.873 19.4546 202.885 56.4669 202.885 102.136Z",
    fill: "url(#paint2_linear_235_112053)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M154.25 93.625L109.261 136.182L88.9961 117.943",
    stroke: "#00993A",
    strokeWidth: 32,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M154.25 82.2766L109.261 124.833L88.9961 106.595",
    stroke: "white",
    strokeWidth: 32,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M222.34 12.895L230.102 27.0941L244.301 34.8561L230.102 42.6181L222.34 56.8171L214.578 42.6181L200.379 34.8561L214.578 27.0941L222.34 12.895Z",
    fill: "#FFCF34"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2817 140.499L25.4913 151.859L36.8506 158.068L25.4913 164.278L19.2817 175.637L13.0722 164.278L1.71289 158.068L13.0722 151.859L19.2817 140.499Z",
    fill: "#FFCF34"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M185.897 106.189L194.504 121.935L210.249 130.542L194.504 139.149L185.897 154.894L177.29 139.149L161.545 130.542L177.29 121.935L185.897 106.189Z",
    fill: "#FFCF34"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_235_112053",
    x1: 121.419,
    y1: 213.593,
    x2: 121.419,
    y2: 0.406925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E5F5E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCEBD2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_235_112053",
    x1: 89.0209,
    y1: 29.1819,
    x2: 156.407,
    y2: 187.586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7ED208"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3FA93D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008071"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_235_112053",
    x1: 79.1866,
    y1: 26.7614,
    x2: 164.989,
    y2: 172.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93D751"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#49C148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AA40"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkArt);
export default __webpack_public_path__ + "static/media/checkmark-art.8b9ab1838140ceaf3d461155c0f99605.svg";
export { ForwardRef as ReactComponent };